<template>
  <v-container class="py-0">
    <v-row dense row wrap>
      <v-col class="col-6 hyp-col-container">
        <span class="application-heading">Verified Events trigger</span>
      </v-col>
      <v-col class="col-6 switch-col-container">
        <v-switch
          v-model="isEnabled"
          @click="handleClick"
          class="pa-0 ma-0"
          solo
          item-text="display"
          return-object
        ></v-switch>
      </v-col>
    </v-row>
    <v-row dense row wrap v-if="isEnabled">
      <v-col class="col-6">
        <v-btn-toggle
          v-model="selection.type"
          class="ml-4"
          @change="handleChange"
        >
          <v-btn value="security" small> Security </v-btn>
          <v-btn value="maritime" small> Maritime </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row dense row wrap v-if="isEnabled">
      <v-col v-if="selection.type === 'security'" class="col-6">
        <v-select
          v-model="categoriesSelected"
          :items="categories"
          label="Categories"
          small-chips
          multiple
          class="ml-4 mt-2 categories"
          @change="handleChange"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";

const EMITTED_ACTIONS = {
  CHANGED: "changed",
  TOGGLED_ON: "toggled-on",
};

export default {
  name: "VerifiedEventsSelector",
  components: {},
  props: {
    selection: {
      type: Object,
    },
  },
  data: () => ({
    topics: [],
    isEnabled: false,
    selectedValue: false,
    categoriesSelected: [],
    categories: ["Crime", "Terrorism", "Unrest", "War"],
  }),
  mounted() {
    this.initialize(true);
  },
  methods: {
    initialize(mounted) {
      let isEnabled =
        lodashGet(this.selection, "type") === "maritime" ||
        (lodashGet(this.selection, "type") === "security" &&
          lodashGet(this.selection, "categories") &&
          this.selection.categories.length);
      this.selectedValue = isEnabled;
      this.categoriesSelected = this.selection.categories;
      if (mounted) {
        this.isEnabled = isEnabled;
      }
    },
    handleClick() {
      if (!this.selectedValue) {
        this.selection.type = null;
        this.selection.categories = [];
      }
      if (this.isEnabled) {
        this.selection.type = "security";
        this.$emit(EMITTED_ACTIONS.TOGGLED_ON);
      }
    },
    handleChange() {
      if (this.selection.type === "maritime") {
        this.categoriesSelected = [];
      }
      this.$emit(EMITTED_ACTIONS.CHANGED, {
        type: this.selection.type,
        categories: this.categoriesSelected,
      });
    },
    disable() {
      this.isEnabled = false;
    },
  },
  watch: {
    selection: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-col-container {
  padding: 12px 12px 0 3px;
  height: 45px;
}
.switch-col-container {
  padding: 12px 12px 0 11px;
  height: 45px;
}
</style>
